import { Button, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormHelperText, IconButton, InputAdornment, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import DraggablePaper from "../common/DraggablePaper";
import { CONTENT_COLOR, MAIN_HEADER_COLOR } from "../../models/Constants";
import { useEffect, useState } from "react";

export type AddTrackLineForm = {
    type1Value : number;
    type2Value : number;
    type3Value : number;
    type4Value : number;
    type5Value : number;
    type6Value : number;
    type7Value : number;
    type8Value : number;
    type9Value : number;
}

export type AddTrackLineProps = {
    data: any;
    onOK: (data: any) => void;
    onCancel: () => void;
};

export const AddTrackLineDialog = (props: AddTrackLineProps) => {
    //#region fields
    const { data, onOK, onCancel } = props;

    // 初期値設定

    const { control, handleSubmit, formState: { errors }, setValue, getValues, setError, clearErrors } = useForm<AddTrackLineForm>({
        mode: "all",
        criteriaMode: "all",
        defaultValues: data,
    })
    //#endregion fields

    //#region methods
    // Submitイベント
    const handleEditSubmit = (value: any, event: any) => {
        const request = createRequestData(value);
        onOK(request);
    }
    
    
    // FormデータからRequestデータを作成する
    const createRequestData = (formValue : AddTrackLineForm) => {       
        let request = {
            ...formValue
        };
        return request;
    }

    //#endregion methods

    return (
        <>
            <Dialog open={true} maxWidth={"xs"} fullWidth
                PaperComponent={
                    DraggablePaper
                }
            >
                <DialogTitle 
                    onMouseOver={(e : any) => e.target.style.cursor = 'move'}
                    style={{ paddingTop: '2px', paddingBottom: '2px', background: MAIN_HEADER_COLOR, color: 'white' }}
                >
                    <Typography variant="h5" color={CONTENT_COLOR}>ボーダー設定</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent style={{paddingTop: '10px', display: 'flex', alignItems: 'flex-end'}}>
                    <div style={{width: '100%', marginTop:"10px"}}>
                        <form onSubmit={handleSubmit(handleEditSubmit)}>
                            <Stack direction={"column"} spacing={2}>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>①対人ストレス耐性</Typography>
                                    <Controller
                                        name="type1Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>②対課題ストレス耐性</Typography>
                                    <Controller
                                        name="type2Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>③対役割ストレス耐性</Typography>
                                    <Controller
                                        name="type3Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>④対環境ストレス耐性</Typography>
                                    <Controller
                                        name="type4Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>⑤自己効力</Typography>
                                    <Controller
                                        name="type5Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>⑥思考のコントロール</Typography>
                                    <Controller
                                        name="type6Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>⑦感情のコントロール</Typography>
                                    <Controller
                                        name="type7Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>⑧サポート活用力</Typography>
                                    <Controller
                                        name="type8Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                                <Stack direction={"row"} spacing={2} alignItems={"center"} width={"100%"} justifyContent={"center"}>
                                    <Typography variant="body1" fontSize={18} width={200}>⑨タフマインド</Typography>
                                    <Controller
                                        name="type9Value"
                                        control={control}
                                        render={({ field: { onChange, value }}) => (
                                            <FormControl>
                                                <Select
                                                value={value}
                                                onChange={onChange}
                                                displayEmpty={false}
                                                sx={{
                                                    width: 80, 
                                                    height: 40, 
                                                }}
                                                >
                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Stack>
                            </Stack>
                            <Stack direction='row' justifyContent="flex-end" gap={2} sx={{ mt: 4 }}>
                                <Button color="inherit" variant="contained" onClick={onCancel} sx={{fontWeight:'bold'}}>キャンセル</Button>
                                <Button variant="contained" type="submit" sx={{fontWeight:'bold'}}>保存</Button>
                            </Stack>
                        </form>
                    </div>                    
                </DialogContent>
            </Dialog>
        </>
    )
}
export default AddTrackLineDialog;